var render = function render(){var _vm=this,_c=_vm._self._c;return _c("div")
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/auth/Logout.vue?vue&type=template&id=a190f3fe&
// module id = null
// module chunks = 